
import React, { useState } from 'react';

export const BooksGridSection: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const books = [
    {
      id: 1,
      title: "Infinite banking concept: How to turn your life insurance policy into your Bank",
      category: "finance",
      image: "https://m.media-amazon.com/images/I/61wWWN27GbL._SY522_.jpg",
      rating: 3.8,
      reviews: 12,
      price: "$7.89",
      format: "Kindle Edition",
      series: "Book 1 of 1: Infinite Banking",
      amazonUrl: "https://www.amazon.com/Infinite-banking-concept-insurance-policy-ebook/dp/B09FSB1M2P"
    },
    {
      id: 2,
      title: "The Infinite Banking Blueprint: Unlocking Your Life Insurance Potential",
      category: "finance",
      image: "https://m.media-amazon.com/images/I/61blvlwskkL._SY522_.jpg",
      rating: 3.9,
      reviews: 2,
      price: "$12.89",
      originalPrice: "$12.98",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/Infinite-Banking-Blueprint-Unlocking-Insurance-ebook/dp/B0DKX7BVL2"
    },
    {
      id: 3,
      title: "Mastering AI-Powered Trading Bots for Options: Analyzing Large Amounts of Data Faster Than Humans Can Read",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/61SiUx+cM6L._SY522_.jpg",
      rating: 5.0,
      reviews: 1,
      price: "$29.89",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/Mastering-AI-Powered-Trading-Bots-Options-ebook/dp/B0CXVF4333"
    },
    {
      id: 4,
      title: "Tax Sales Overages Who Took My Money",
      category: "real-estate",
      image: "https://m.media-amazon.com/images/I/81cVcPL2wrL._SY522_.jpg",
      rating: 3.3,
      reviews: 5,
      price: "Free",
      originalPrice: "$7.89",
      format: "Kindle Edition",
      series: "Book 1 of 1: Tax Sales Overages Who Took My Money",
      kindleUnlimited: true,
      amazonUrl: "https://www.amazon.com/Tax-Sales-Overages-Took-Money-ebook/dp/B09J38W4HD"
    },
    {
      id: 5,
      title: "How to Use Infinite Banking to Purchase Tax Lien Foreclosure: Benefits and Risks of Buying A Property At A Tax Lien Foreclosure Sale",
      category: "finance",
      image: "https://m.media-amazon.com/images/I/81nLKp4gWPL._SY522_.jpg",
      rating: 3.0,
      reviews: 4,
      price: "$7.68",
      format: "Kindle Edition",
      series: "Related to: Infinite Banking",
      amazonUrl: "https://www.amazon.com/Infinite-Banking-Purchase-Lien-Foreclosure-ebook/dp/B09GRTLFPX"
    },
    {
      id: 6,
      title: "The Prosperity Puzzle: The Joy of Achieving Financial Prosperity",
      category: "business",
      image: "https://m.media-amazon.com/images/I/716PJmyATeL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$23.79",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/Prosperity-Puzzle-Joy-Achieving-Financial-ebook/dp/B0DP23YZ96"
    },
    {
      id: 7,
      title: "The First-Time Author's Playbook: Navigating the Publishing World",
      category: "business",
      image: "https://m.media-amazon.com/images/I/71Xl8K9+1cL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$12.89",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/First-Time-Authors-Playbook-Navigating-Publishing-ebook/dp/B0D78325LG"
    },
    {
      id: 8,
      title: "Embracing Your Why: A Guide to Finding Purpose in Life",
      category: "personal-growth",
      image: "https://m.media-amazon.com/images/I/719eflVmMaL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$8.78",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/Embracing-Your-Why-Finding-Purpose-ebook/dp/B0DKQR2MHH"
    },
    {
      id: 9,
      title: "AI Investing For Gen Z (AI Series By Jeffery Long Book 2)",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/81nnbJjTVtL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$8.69",
      originalPrice: "$11.78",
      format: "Kindle Edition",
      series: "Book 2 of 3: AI Series By Jeffery Long",
      amazonUrl: "https://www.amazon.com/Investing-Gen-Jeffery-Long-Book-ebook/dp/B0DGX7M77G"
    },
    {
      id: 10,
      title: "Living with AI: Practical Tools for Beginners (AI Series By Jeffery Long Book 1)",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/81qA2TElv0L._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$17.89",
      format: "Kindle Edition",
      series: "Book 1 of 3: AI Series By Jeffery Long",
      amazonUrl: "https://www.amazon.com/Living-AI-Practical-Beginners-Jeffery-ebook/dp/B0DF4XLJ1Q"
    },
    {
      id: 11,
      title: "Advanced Techniques For Using AI to Master Crypto",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/81V2FA+iguL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$48.89",
      originalPrice: "$49.89",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/Advanced-Techniques-Using-Master-Crypto-ebook/dp/B0DDWWJBV7"
    },
    {
      id: 12,
      title: "The AI Investor: Strategies for Secure Crypto Purchases",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/81eV9Pks63L._SY522_.jpg",
      rating: 3.4,
      reviews: 3,
      price: "$28.88",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/AI-Investor-Strategies-Secure-Purchases-ebook/dp/B0DDBMLR36"
    },
    {
      id: 13,
      title: "AI Insights: Automating Your Crypto Research for Smarter Investments",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/816ET6rcuEL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$28.88",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/AI-Insights-Automating-Research-Investments-ebook/dp/B0DDBGG2Q8"
    },
    {
      id: 14,
      title: "Write The Vision and Make it Plain: A Practical Guide to Achieving Your Dreams",
      category: "personal-growth",
      image: "https://m.media-amazon.com/images/I/814YtQAMSFL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "Free",
      originalPrice: "$24.89",
      format: "Kindle Edition",
      kindleUnlimited: true,
      amazonUrl: "https://www.amazon.com/Write-Vision-Make-Plain-Practical-ebook/dp/B0DCGFYJL7"
    },
    {
      id: 15,
      title: "AI Future Fortunes: AI-Powered Trends for Long-Term Investors",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/81O8dKwx3iL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$25.98",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/Future-Fortunes-AI-Powered-Long-Term-Investors-ebook/dp/B0D8GMHBB1"
    },
    {
      id: 16,
      title: "Mastering AI for Business: A Comprehensive Guide to Artificial Intelligence in the Modern Workplace",
      category: "ai",
      image: "https://m.media-amazon.com/images/I/81xKpQzVJeL._SY522_.jpg",
      rating: null,
      reviews: 0,
      price: "$39.89",
      format: "Kindle Edition",
      amazonUrl: "https://www.amazon.com/Mastering-Business-Comprehensive-Artificial-Intelligence-ebook/dp/B0D6LTDYD5"
    }
  ];

  const categories = [
    { id: 'all', name: 'All Books', count: books.length },
    { id: 'ai', name: 'AI & Technology', count: books.filter(book => book.category === 'ai').length },
    { id: 'finance', name: 'Finance & Banking', count: books.filter(book => book.category === 'finance').length },
    { id: 'business', name: 'Business Development', count: books.filter(book => book.category === 'business').length },
    { id: 'real-estate', name: 'Real Estate', count: books.filter(book => book.category === 'real-estate').length },
    { id: 'personal-growth', name: 'Personal Growth', count: books.filter(book => book.category === 'personal-growth').length }
  ];

  const filteredBooks = selectedCategory === 'all' 
    ? books 
    : books.filter(book => book.category === selectedCategory);

  const renderStars = (rating: number | null) => {
    if (!rating) return null;
    
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="flex items-center">
        {[...Array(fullStars)].map((_, i) => (
          <i key={i} className="ri-star-fill text-yellow-400"></i>
        ))}
        {hasHalfStar && <i className="ri-star-half-fill text-yellow-400"></i>}
        {[...Array(emptyStars)].map((_, i) => (
          <i key={i} className="ri-star-line text-gray-300"></i>
        ))}
        <span className="ml-2 text-sm text-gray-600">
          {rating} ({books.find(b => b.rating === rating)?.reviews || 0} reviews)
        </span>
      </div>
    );
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.src = "https://public.readdy.ai/ai/img_res/f686b22e075bf8902b1de3e794928757.jpg";
  };

  return (
    <section id="books" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Published Books Collection</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore my comprehensive library of {books.length} published works covering AI, finance, business development, real estate, and personal growth.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 whitespace-nowrap ${
                selectedCategory === category.id
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600 shadow-md'
              }`}
            >
              {category.name} ({category.count})
            </button>
          ))}
        </div>

        {/* Books Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {filteredBooks.map((book) => (
            <div key={book.id} className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group flex flex-col h-full">
              <div className="relative overflow-hidden">
                <img
                  src={book.image}
                  alt={book.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                  onError={handleImageError}
                />
                {book.kindleUnlimited && (
                  <div className="absolute top-2 right-2 bg-orange-500 text-white px-2 py-1 rounded text-xs font-semibold">
                    Kindle Unlimited
                  </div>
                )}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
              </div>
              
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
                  {book.title}
                </h3>
                
                {book.series && (
                  <p className="text-sm text-blue-600 mb-2">{book.series}</p>
                )}
                
                {book.rating && (
                  <div className="mb-3">
                    {renderStars(book.rating)}
                  </div>
                )}
                
                <p className="text-sm text-gray-600 mb-3">{book.format}</p>
                
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-2">
                    <span className="text-lg font-bold text-gray-900">
                      {book.price === "Free" ? "Free" : book.price}
                    </span>
                    {book.originalPrice && (
                      <span className="text-sm text-gray-500 line-through">
                        {book.originalPrice}
                      </span>
                    )}
                  </div>
                  {book.kindleUnlimited && book.price === "Free" && (
                    <span className="text-xs text-orange-600 font-semibold">
                      or {book.originalPrice} to buy
                    </span>
                  )}
                </div>
                
                <div className="mt-auto">
                  <a
                    href={book.amazonUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-center block whitespace-nowrap"
                  >
                    View on Amazon
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All on Amazon */}
        <div className="text-center mt-12">
          <a
            href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5/allbooks"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-orange-500 text-white px-8 py-4 rounded-lg hover:bg-orange-600 transition-colors font-semibold text-lg whitespace-nowrap"
          >
            <i className="ri-amazon-line mr-2"></i>
            View Complete Collection on Amazon
          </a>
        </div>
      </div>
    </section>
  );
};
